import {Loader, LoaderOptions} from "google-maps"

const mapElement = document.getElementById("map_inline")

const initMap = async () => {
  if (mapElement === null) return

  const mapSettings = JSON.parse(mapElement?.getAttribute("data-map") ?? "")

  const options: LoaderOptions = {}
  const loader = new Loader(mapSettings.key, options)

  const google = await loader.load()

  const map = new google.maps.Map(mapElement, {
    center: mapSettings.center,
    zoom: mapSettings.zoom,
    fullscreenControl: false,
    streetViewControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.LEFT_BOTTOM,
    },
  })

  const markersData = JSON.parse(mapElement?.getAttribute("data-markers") ?? "")

  const infowindow = new google.maps.InfoWindow({
    disableAutoPan: true,
  })

  markersData.forEach((markerDataSet) => {
    const iconDefault = {
      url: mapSettings.markerIcon.url,
      scaledSize: new google.maps.Size(48, 62),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(24, 0),
    }

    const markers: google.maps.Marker[] = []

    markerDataSet.data.forEach((markerData) => {
      const marker = new google.maps.Marker({
        position: markerData,
        map: map,
        icon: iconDefault,
      })

      marker.addListener("click", () => {
        infowindow.close()
        if (!markerData.infoWindow) return

        if (markerData.infoWindow.branch) {
          infowindow.setContent(`
          <div class="main-inline-map__iw">
            <img class="main-inline-map__iw-image" src="${markerData.infoWindow.branch.image}" loading="lazy">
            <div class="main-inline-map__iw-content">
              <span class="main-inline-map__city">${markerData.infoWindow.branch.city}</span>
              <span class="main-inline-map__type">${markerData.infoWindow.branch.type}</span>
              <span class="main-inline-map__address">${markerData.infoWindow.branch.address}</span>
              <a class="main-inline-map__link" href="${markerData.infoWindow.branch.link}">${markerData.infoWindow.branch.link_label}</a>
            </div>
          </div> `)
        }

        infowindow.open(map, marker)
      })

      markers.push(marker)
    })
  })
}
initMap()
